import ReservationsAPI from '@/API/ReservationsAPI'

export default {
  namespaced: true,
  state: {
    tables: [],
    enabled: true,
    qr_link: '',
    fetched: false,
    noReservation: false,
  },

  getters: {
    tables: (state: any) => state.tables,
    isEnabled: (state: any) => state.enabled,
    qrLink: (state: any) => state.qr_link,
    noReservation: (state: any) => state.noReservation,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.tables = payload.tables ?? []
      state.enabled = payload.enabled ?? true
      state.qr_link = payload.qr_link ?? ''
      state.noReservation = payload.noReservation ?? false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      if (context.state.fetched) {
        return
      }
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await ReservationsAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
    async UPDATE(context: any, payload: any) {
      // @ts-ignore
      try {
        return await ReservationsAPI.updateStatus(payload)
      } catch (err) {
        return { response: 400, message: err?.message ?? '' }
      }
    },
  },
}
